// Tipus per al joc de Poker Texas Hold'em

export type Suit = '♠' | '♥' | '♦' | '♣';
export type Rank = '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | 'J' | 'Q' | 'K' | 'A';

export interface Card {
  suit: Suit;
  rank: Rank;
  hidden?: boolean;
}

export interface Player {
  id: string;
  name: string;
  avatar: string;
  chips: number;
  cards: Card[];
  bet: number;           // Aposta en la ronda actual
  totalBet: number;      // Total apostat en la mà
  folded: boolean;
  hasActed: boolean;     // Si ha actuat en aquesta ronda
  isAllIn: boolean;      // Si ha fet all-in
  isDealer: boolean;
  isCurrentPlayer: boolean;
  isHuman: boolean;
  lastAction?: string;   // Última acció realitzada
}

export type GamePhase = 'waiting' | 'preflop' | 'flop' | 'turn' | 'river' | 'showdown';

export type HandRank = 
  | 'Carta Alta'
  | 'Parella'
  | 'Doble Parella'
  | 'Trio'
  | 'Escala'
  | 'Color'
  | 'Full'
  | 'Poker'
  | 'Escala de Color'
  | 'Escala Reial';

export interface HandEvaluation {
  rank: HandRank;
  score: number;
  cards: Card[];
}

export interface GameState {
  phase: GamePhase;
  players: Player[];
  communityCards: Card[];
  pot: number;
  currentBet: number;        // Aposta més alta de la ronda actual
  minRaise: number;          // Mínim per pujar
  currentPlayerIndex: number;
  dealerIndex: number;
  smallBlind: number;
  bigBlind: number;
  deck: Card[];
  winner: Player | null;
  winningHand: HandRank | null;
  lastAggressor: number;     // Qui va fer l'última puja
  roundStartPlayer: number;  // Qui comença la ronda
}

export interface PlayerAction {
  type: 'fold' | 'check' | 'call' | 'bet' | 'raise' | 'all-in';
  amount?: number;
}

// Avatars disponibles (només animals)
export const AVATARS = ['🐮', '🐸', '🦄', '🐱', '🐶', '🦊', '🐼', '🐨', '🐷', '🐵', '🦁', '🐯', '🐻', '🐰', '🦝'];

// Noms dels jugadors (només 4)
export const PLAYER_NAMES = [
  'Usuari 1', 'Usuari 2', 'Usuari 3', 'Usuari 4'
];
